// Импорты изображений категорий
import { ScreenSize } from '../hooks/useGetScreenSize';
import familyImg from '../images/categories/family.png';
import educationImg from '../images/categories/education.png';
import careerImg from '../images/categories/career.png';
import cookingImg from '../images/categories/cooking.png';
import gardenImg from '../images/categories/garden.png';
import petsImg from '../images/categories/pets.png';
import repairImg from '../images/categories/repair.png';
import householdImg from '../images/categories/household.png';
import businessImg from '../images/categories/business.png';
import savingsImg from '../images/categories/savings.png';
import healthImg from '../images/categories/health.png';
import psychologyImg from '../images/categories/psychology.png';
import gadgetsImg from '../images/categories/gadgets.png';
import travelImg from '../images/categories/travel.png';
import nutritionImg from '../images/categories/nutrition.png';
import selfDevelopmentImg from '../images/categories/self-development.png';
import moviesImg from '../images/categories/movies.png';
import fashionImg from '../images/categories/fashion.png';
import sportsImg from '../images/categories/sports.png';
import literatureImg from '../images/categories/literature.png';
import shoppingImg from '../images/categories/shopping.png';
import autoImg from '../images/categories/auto.png';
import beautyImg from '../images/categories/beauty.png';
import productivityImg from '../images/categories/productivity.png';
import studyImg from '../images/categories/study.png';
import itImg from '../images/categories/it.png';
import gamesImg from '../images/categories/games.png';
import communicationImg from '../images/categories/communication.png';
import lawImg from '../images/categories/law.png';
import financeImg from '../images/categories/finance.png';
import photoVideoImg from '../images/categories/photo-video.png';
import researchImg from '../images/categories/research.png';
import musicImg from '../images/categories/music.png';
import parentingImg from '../images/categories/parenting.png';
import hobbiesImg from '../images/categories/hobbies.png';
import ecologyImg from '../images/categories/ecology.png';
import artImg from '../images/categories/art.png';
import securityImg from '../images/categories/security.png';
import natureImg from '../images/categories/nature.png';
import holidaysImg from '../images/categories/holidays.png';
import humorImg from '../images/categories/humor.png';
import transportImg from '../images/categories/transport.png';
import teachingImg from '../images/categories/teaching.png';
import charityImg from '../images/categories/charity.png';
import realEstateImg from '../images/categories/real-estate.png';
import leisureImg from '../images/categories/leisure.png';
import geographyImg from '../images/categories/geography.png';
import miscImg from '../images/categories/misc.png';
import photoRevivalImg from '../images/categories/photo-revival.png';

// Импорты видео категорий
import artVideo from '../images/categories/art.mp4';
import businessVideo from '../images/categories/business.mp4';
import careerVideo from '../images/categories/career.mp4';
import charityVideo from '../images/categories/charity.mp4';
import cookingVideo from '../images/categories/cooking.mp4';
import familyVideo from '../images/categories/family.mp4';
import fashionVideo from '../images/categories/fashion.mp4';
import financeVideo from '../images/categories/finance.mp4';
import gardenVideo from '../images/categories/garden.mp4';
import healthVideo from '../images/categories/health.mp4';
import householdVideo from '../images/categories/household.mp4';
import itVideo from '../images/categories/it.mp4';
import lawVideo from '../images/categories/law.mp4';
import leisureVideo from '../images/categories/leisure.mp4';
import moviesVideo from '../images/categories/movies.mp4';
import natureVideo from '../images/categories/nature.mp4';
import parentingVideo from '../images/categories/parenting.mp4';
import petsVideo from '../images/categories/pets.mp4';
import photoRevivalVideo from '../images/categories/photo-revival.mp4';
import psychologyVideo from '../images/categories/psychology.mp4';
import realEstateVideo from '../images/categories/real-estate.mp4';
import securityVideo from '../images/categories/security.mp4';
import sportsVideo from '../images/categories/sports.mp4';
import studyVideo from '../images/categories/study.mp4';
import transportVideo from '../images/categories/transport.mp4';
import travelVideo from '../images/categories/travel.mp4';
import researchVideo from '../images/categories/research.mp4';

export type Category = {
    id: string;
    name: string;
    image: string;
    video?: string;
    disabled?: boolean;
    priority?: number;
    hidden?: boolean; // Категория существует, но скрыта от пользователей
};

/**
 * Список всех категорий с обработанными webpack путями к изображениям
 */
export const categories: Category[] = [
    // Активные категории с приоритетами для брейкпоинтов
    // Priority 1-7: показываются на всех брейкпоинтах (Mobile 7+)
    { id: 'research', name: 'Исследование', image: researchImg, hidden: true, video: researchVideo, priority: 0 },
    { id: 'study', name: 'Учёба', image: studyImg, video: studyVideo, priority: 1 },
    { id: 'career', name: 'Карьера', image: careerImg, video: careerVideo, priority: 2 },
    { id: 'health', name: 'Здоровье', image: healthImg, video: healthVideo, priority: 3 },
    { id: 'household', name: 'Дом', image: householdImg, video: householdVideo, priority: 4 },
    { id: 'family', name: 'Отношения', image: familyImg, video: familyVideo, priority: 5 },
    { id: 'travel', name: 'Путешествия', image: travelImg, video: travelVideo, priority: 6 },
    { id: 'photo-revival', name: 'Оживи фото', image: photoRevivalImg, video: photoRevivalVideo, priority: 7 },

    // Priority 8-9: добавляются с Tablet (9+)
    { id: 'fashion', name: 'Мода и стиль', image: fashionImg, video: fashionVideo, priority: 8 },
    { id: 'parenting', name: 'Дети', image: parentingImg, video: parentingVideo, priority: 9 },

    // Priority 10-13: добавляются с Desktop (13+)
    { id: 'business', name: 'Бизнес и маркетинг', image: businessImg, video: businessVideo, priority: 10 },
    { id: 'finance', name: 'Финансы', image: financeImg, video: financeVideo, priority: 11 },
    { id: 'it', name: 'Технологии', image: itImg, video: itVideo, priority: 12 },
    { id: 'sports', name: 'Спорт', image: sportsImg, video: sportsVideo, priority: 13 },

    // Priority 14-15: добавляются с LargeDesktop (15+)
    { id: 'leisure', name: 'Досуг', image: leisureImg, video: leisureVideo, priority: 14 },
    { id: 'law', name: 'Право', image: lawImg, video: lawVideo, priority: 15 },

    // Остальные активные категории (без приоритета, уходят в "Ещё")
    { id: 'psychology', name: 'Психология', image: psychologyImg, video: psychologyVideo },
    { id: 'real-estate', name: 'Недвижимость', image: realEstateImg, video: realEstateVideo },
    { id: 'art', name: 'Искусство', image: artImg, video: artVideo },
    { id: 'security', name: 'Безопасность', image: securityImg, video: securityVideo },
    { id: 'nature', name: 'Природа', image: natureImg, video: natureVideo },
    { id: 'transport', name: 'Транспорт', image: transportImg, video: transportVideo },
    { id: 'charity', name: 'Благотворительность', image: charityImg, video: charityVideo },
    { id: 'cooking', name: 'Кулинария', image: cookingImg, video: cookingVideo },
    { id: 'pets', name: 'Питомцы', image: petsImg, video: petsVideo },
    { id: 'garden', name: 'Сад и растения', image: gardenImg, video: gardenVideo },
    { id: 'movies', name: 'Кино', image: moviesImg, video: moviesVideo },

    // Отключенные категории
    { id: 'education', name: 'Образование', image: educationImg, disabled: true },
    { id: 'repair', name: 'Ремонт', image: repairImg, disabled: true },
    { id: 'savings', name: 'Экономия', image: savingsImg, disabled: true },
    { id: 'gadgets', name: 'Гаджеты', image: gadgetsImg, disabled: true },
    { id: 'nutrition', name: 'Питание', image: nutritionImg, disabled: true },
    { id: 'self-development', name: 'Саморазвитие', image: selfDevelopmentImg, disabled: true },
    { id: 'literature', name: 'Литература', image: literatureImg, disabled: true },
    { id: 'shopping', name: 'Шопинг', image: shoppingImg, disabled: true },
    { id: 'auto', name: 'Авто', image: autoImg, disabled: true },
    { id: 'beauty', name: 'Красота', image: beautyImg, disabled: true },
    { id: 'productivity', name: 'Продуктивность', image: productivityImg, disabled: true },
    { id: 'games', name: 'Игры', image: gamesImg, disabled: true },
    { id: 'communication', name: 'Общение', image: communicationImg, disabled: true },
    { id: 'photo-video', name: 'Фото и видео', image: photoVideoImg, disabled: true },
    { id: 'music', name: 'Музыка', image: musicImg, disabled: true },
    { id: 'hobbies', name: 'Хобби', image: hobbiesImg, disabled: true },
    { id: 'ecology', name: 'Экология', image: ecologyImg, disabled: true },
    { id: 'holidays', name: 'Праздники', image: holidaysImg, disabled: true },
    { id: 'humor', name: 'Юмор', image: humorImg, disabled: true },
    { id: 'teaching', name: 'Преподавание', image: teachingImg, disabled: true },
    { id: 'geography', name: 'География', image: geographyImg, disabled: true },
    { id: 'misc', name: 'Разное', image: miscImg, disabled: true },
];

/**
 * Список ID скрытых категорий (hidden: true)
 * Используется для фильтрации промптов и проверок видимости
 */
export const hiddenCategoryIds: string[] = categories.filter(category => category.hidden).map(category => category.id);

/**
 * Возвращает только активные категории (без disabled: true)
 */
export function getActiveCategories(): Category[] {
    return categories.filter(category => !category.disabled);
}

/**
 * Возвращает категории для отображения с учетом выбранных
 * Скрытые категории показываются только если они выбраны
 * @param selectedCategories - массив ID выбранных категорий
 * @returns массив категорий для отображения
 */
export function getCategoriesForDisplay(selectedCategories: string[] = []): Category[] {
    return categories.filter(category => {
        // Исключаем отключенные категории
        if (category.disabled) {
            return false;
        }

        // Показываем видимые категории всегда
        if (!category.hidden) {
            return true;
        }

        // Скрытые категории показываем только если они выбраны
        return selectedCategories.includes(category.id);
    });
}

/**
 * Возвращает категории для отображения на конкретном брейкпоинте
 * Категории сортируются по приоритету, затем берутся первые N для брейкпоинта
 *
 * @param screenSize - размер экрана
 * @param selectedCategories - массив ID выбранных категорий (для показа скрытых)
 * @returns массив категорий для отображения (без кнопки "Ещё")
 */
export function getCategoriesForBreakpoint(screenSize: ScreenSize, selectedCategories: string[] = []): Category[] {
    // Определяем количество категорий для каждого брейкпоинта
    const categoryCount: Record<ScreenSize, number> = {
        [ScreenSize.Mobile]: 7,
        [ScreenSize.Tablet]: 9,
        [ScreenSize.SmallDesktop]: 9,
        [ScreenSize.Desktop]: 13,
        [ScreenSize.MiddleDesktop]: 13,
        [ScreenSize.LargeDesktop]: 15,
    };

    const count = categoryCount[screenSize] || 7;

    // Получаем категории для отображения с учетом выбранных
    const displayCategories = getCategoriesForDisplay(selectedCategories);

    // Сортируем по приоритету (меньше = выше приоритет)
    // Категории без приоритета идут в конец
    const sortedCategories = [...displayCategories].sort((a, b) => {
        const priorityA = a.priority ?? Number.MAX_SAFE_INTEGER;
        const priorityB = b.priority ?? Number.MAX_SAFE_INTEGER;

        return priorityA - priorityB;
    });

    // Возвращаем первые N категорий
    return sortedCategories.slice(0, count);
}
